module.exports = __webpack_public_path__ + "static/media/psych.9ae9ab7c.jpg";